// src/App.js
import {
  createBrowserRouter,
  RouterProvider,
  redirect
} from "react-router-dom";
import './App.css';
import './IPRChart.css';

import { useContext } from "react";
import { ToastContainer } from "react-toastify";

// Auth Pages
import Login from "./routes/login/Login";
import Layout from "./routes/layout/Layout";
import NoRecords from "./components/NoRecords";
import Dashboard from "./routes/dashboard/Dashboard";
import NotAuthorized from "./components/NotAuthorized";
import ResetPassword from "./routes/reset-password/ResetPassword";

// Client's Login Pages
import KlarLogin from "./routes/login/KlarLogin";
import Neo3DLogin from "./routes/login/Neo3DLogin";
import SecretLogin from "./routes/login/SecretLogin";
import DencadLogin from "./routes/login/DencadLogin";
import CleverLogin from "./routes/login/CleverLogin";
import DarrenLogin from "./routes/login/DarrenLogin";
import WeSmileLogin from "./routes/login/WeSmileLogin";
import SmilezyLogin from "./routes/login/SmilezyLogin";
import BioDentLogin from "./routes/login/BioDentLogin";
import ClearArtLogin from "./routes/login/ClearArtLogin";
import SmileTrueLogin from "./routes/login/SmileTrueLogin";
import OrthoVeerLogin from "./routes/login/OrthoVeerLogin";
import BrightArkLogin from "./routes/login/BrightArkLogin";
import DrabhishekLogin from "./routes/login/DrabhishekLogin";
import SmileGenixLogin from "./routes/login/SmileGenixLogin";
import Str8AlignersLogin from "./routes/login/Str8AlignersLogin";
import LuneoAlignerLogin from "./routes/login/LuneoAlignerLogin";
import MySmartAlignLogin from "./routes/login/MySmartAlignLogin";
import BriteAlignersLogin from "./routes/login/BriteAlignersLogin";
import DreamAlignersLogin from "./routes/login/DreamAlignersLogin";
import AkiraAlignersLogin from "./routes/login/AkiraAlignersLogin";
import CaClearAlignerLogin from "./routes/login/CaClearAlignerLogin";
import DrClearAlignersLogin from "./routes/login/DrClearAlignersLogin";
import InvisibleBracesLogin from "./routes/login/InvisibleBracesLogin";
import LifeOrthodonticsLogin from "./routes/login/LifeOrthodonticsLogin";
import SunsetDentalCenterLogin from "./routes/login/SunsetDentalCenterLogin";
import LetzeSmileAlignersLogin from "./routes/login/LetzeSmileAlignersLogin";

//Notifications component
import Notifications from "./routes/notifications/Notifications";

//Users componets
import Users from "./routes/users/Users";
import CreateUser from "./routes/users/CreateUser";
import EditUser from "./routes/users/EditUser";
import UserDetail from "./routes/users/UserDetail";

//Permissions? componets
import Permissions from "./routes/permissions/Permissions";
import AddPermission from "./routes/permissions/AddPermission";
import PermissionDetail from "./routes/permissions/PermissionDetail";
import UpdatePermission from "./routes/permissions/UpdatePermission";

//Roles componets
import Roles from "./routes/roles/Roles";
import AddRole from "./routes/roles/AddRole";
import RoleDetail from "./routes/roles/RoleDetail";
import UpdateRole from "./routes/roles/UpdateRole";

//cases components
import CreateCase from "./routes/cases/CreateCase";
import CaseDetail from "./routes/cases/CaseDetail";
import Cases from "./routes/cases/Cases";
import UpdateCase from "./routes/cases/UpdateCase";
import CompletedCases from "./routes/cases/CompletedCases";
import CasePlanUploadUpdate from "./routes/cases/components/CasePlanUploadUpdate";

//History components
import Histoy from "./routes/history/Histoy";
import HistoyDetail from "./routes/history/HistoyDetail";

//Approval components
import CreateApproval from "./routes/pending-approvals/CreateApproval";
import PendingApprovals from "./routes/pending-approvals/PendingApprovals";
import ApprovalDetail from "./routes/pending-approvals/ApprovalDetails";
import UpdateApproval from "./routes/pending-approvals/UpdateApproval";
import { AuthContext } from "./components/authcontext/AuthContext";

// Sub client components
import SubClients from "./routes/subclients/SubClients";
import SubClientDetail from "./routes/subclients/SubClientDetail";
import CreateSubClient from "./routes/subclients/CreateSubClient";
import UpdateSubClient from "./routes/subclients/UpdateSubClient";

// Teams components
import Teams from "./routes/teams/Teams";
import CreateTeam from "./routes/teams/CreateTeam";
import UpdateTeam from "./routes/teams/UpdateTeam";
import TeamDetail from "./routes/teams/TeamDetail";

function App() {

  const { currentUser, loading } = useContext(AuthContext)

  if (loading) {
    return (
      <div className="loader-parent">
        <div className="_loader"></div>
      </div>
    );
  }

  const permissions = currentUser?.permissions

  const AdminsUser = ({ children }) => {
    return <>{children}</>
  }

  const router = createBrowserRouter([
    { path: "/login", element: <Login /> },
    
    // Client login pages
    { path: "/klar", element: <KlarLogin /> },
    { path: "/neo3d", element: <Neo3DLogin /> },
    { path: "/cleverlogin", element: <CleverLogin /> },
    { path: "/darrenlogin", element: <DarrenLogin /> },
    { path: "/dencadlogin", element: <DencadLogin /> },
    { path: "/brightark", element: <BrightArkLogin /> },
    { path: "/orthoveer", element: <OrthoVeerLogin /> },
    { path: "/secretaligner", element: <SecretLogin /> },
    { path: "/smilezylogin", element: <SmilezyLogin /> },
    { path: "/biodentlogin", element: <BioDentLogin /> },
    { path: "/wesmilelogin", element: <WeSmileLogin /> },
    { path: "/clearart-login", element: <ClearArtLogin /> },
    { path: "/smiletrue-login", element: <SmileTrueLogin /> },
    { path: "/drabhisheklogin", element: <DrabhishekLogin /> },
    { path: "/smilegenix-login", element: <SmileGenixLogin /> },
    { path: "/dreamaligners", element: <DreamAlignersLogin /> },
    { path: "/akiraaligners", element: <AkiraAlignersLogin /> },
    { path: "/mysmartalignlogin", element: <MySmartAlignLogin /> },
    { path: "/str8aligners-login", element: <Str8AlignersLogin /> },
    { path: "/luneoaligner-login", element: <LuneoAlignerLogin /> },
    { path: "/drclearaligners", element: <DrClearAlignersLogin /> },
    { path: "/lifeorthodontics", element: <LifeOrthodonticsLogin /> },
    { path: "/britealigners-login", element: <BriteAlignersLogin /> },
    { path: "/caclearaligner-login", element: <CaClearAlignerLogin /> },
    { path: "/invisiblebraces-login", element: <InvisibleBracesLogin /> },
    { path: "/letzesmilealigners", element: <LetzeSmileAlignersLogin /> },
    { path: "/sensetdental-login", element: <SunsetDentalCenterLogin /> },

    {
      path: "/",
      loader: () => {
        return redirect("/dashboard");
      }
    },
    {
      path: "*",
      element: <NoRecords />,
    },
    {
      path: "/",
      element: <AdminsUser> <Layout /> </AdminsUser>,
      children: [
        {
          path: "/dashboard",
          element: <Dashboard />
        },
        //Users routes
        {
          path: "/users",
          element: permissions?.includes('users-list') ? <Users /> : <NotAuthorized />
        },
        {
          path: "/create-user",
          element: permissions?.includes('users-store') ? <CreateUser /> : <NotAuthorized />
        },
        {
          path: "/edit-user/:id",
          element: permissions?.includes('users-update') ? <EditUser /> : <NotAuthorized />
        },
        {
          path: "/user-detail/:id",
          element: permissions?.includes('users-update') ? <UserDetail /> : <NotAuthorized />
        },
        //notifications
        {
          path: "/notifications",
          element: <Notifications />
        },
        //History
        {
          path: "/history",

          element: <Histoy />
        },
        {
          path: "/history-detail/:id",
          element: <HistoyDetail />
        },
        //cases
        {
          path: "/cases/:casestatus?",
          element: permissions?.includes('patient-cases-list') ? <Cases /> : <NotAuthorized />
        },
        {
          path: "/completed-cases",
          element: permissions?.includes('patient-cases-list') ? <CompletedCases /> : <NotAuthorized />
        },
        {
          path: "/create-case",
          element: permissions?.includes('patient-cases-store') ? <CreateCase /> : <NotAuthorized />
        },
        {
          path: "/update-case/:id",
          element: permissions?.includes('patient-cases-update') ? <UpdateCase /> : <NotAuthorized />
        },
        {
          path: "/case-detail/:id",
          element: permissions?.includes('patient-cases-detail') ? <CaseDetail /> : <NotAuthorized />
        },
        {
          path: "/case-detail/plan/:id",
          element: permissions?.includes('case-plan-update') ? <CasePlanUploadUpdate /> : <CasePlanUploadUpdate />
        },
        //approvals routes
        {
          path: "/approvals",
          element: permissions?.includes('pending-approvals-list') ? <PendingApprovals /> : <NotAuthorized />
        },
        {
          path: "/create-approval",
          element: permissions?.includes('pending-approvals-store') ? <CreateApproval /> : <NotAuthorized />
        },
        {
          path: "/update-approval/:id",
          element: permissions?.includes('pending-approvals-update') ? <UpdateApproval /> : <NotAuthorized />
        },
        {
          path: "/approval-detail/:id",
          element: permissions?.includes('pending-approvals-detail') ? <ApprovalDetail /> : <NotAuthorized />
        },
        //Roles routes
        {
          path: "/roles",
          element: permissions?.includes('roles-list') ? <Roles /> : <NotAuthorized />
        },
        {
          path: "/add-role",
          element: permissions?.includes('roles-store') ? <AddRole /> : <NotAuthorized />
        },
        {
          path: "/update-role/:id",
          element: permissions?.includes('roles-update') ? <UpdateRole /> : <NotAuthorized />
        },
        {
          path: "/role-detail/:id",
          element: permissions?.includes('roles-detail') ? <RoleDetail /> : <NotAuthorized />
        },

        //Permissions? routes
        {
          path: "/permissions",
          element: permissions?.includes('permissions-list') ? <Permissions /> : <NotAuthorized />
        },
        {
          path: "/add-permission",
          element: permissions?.includes('permissions-store') ? <AddPermission /> : <NotAuthorized />
        },
        {
          path: "/update-permission/:id",
          element: permissions?.includes('permissions-update') ? <UpdatePermission /> : <NotAuthorized />
        },
        {
          path: "/permission-detail/:id",
          element: permissions?.includes('permissions-detail') ? <PermissionDetail /> : <NotAuthorized />
        },

        //teams
        {
          path: "/teams",
          element: permissions?.includes('teams-list') ? <Teams /> : <NotAuthorized />
        },
        {
          path: "/create-team",
          element: permissions?.includes('teams-store') ? <CreateTeam /> : <NotAuthorized />
        },
        {
          path: "/update-team/:id",
          element: permissions?.includes('teams-update') ? <UpdateTeam /> : <NotAuthorized />
        },
        {
          path: "/team-detail/:id",
          element: permissions?.includes('teams-detail') ? <TeamDetail /> : <NotAuthorized />
        },

        //sub clients
        {
          path: "/sub-clients",
          element: permissions?.includes('sub-client-list') ? <SubClients /> : <NotAuthorized />
        },
        {
          path: "/create-sub-client",
          element: permissions?.includes('sub-client-store') ? <CreateSubClient /> : <NotAuthorized />
        },
        {
          path: "/update-sub-client/:id",
          element: permissions?.includes('sub-client-update') ? <UpdateSubClient /> : <NotAuthorized />
        },
        {
          path: "/sub-client-detail/:id",
          element: permissions?.includes('sub-client-detail') ? <SubClientDetail /> : <NotAuthorized />
        },
        {
          path: "/reset-password",
          element: permissions?.includes('reset-password') ? <ResetPassword /> : <NotAuthorized />
        },

      ]
    }
  ]);

  return (
    <>
      <ToastContainer />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
